import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../../createStore';
import {AnnouncementDto, mapiqApi} from '@lib/infrastructure';
import {getIsFeatureEnabled} from '../../infrastructure';
import {FeatureToggle} from '../entities';

export const getUserAnnouncements = createAsyncThunk<AnnouncementDto[], void, AppThunkApiConfig>(
  'employeeCommunication/getUserAnnouncements',
  async (_, {extra}) => {
    const api = mapiqApi(extra.apiClient);
    const announcements = await api.getUserAnnouncements();

    return announcements;
  },
  {
    condition: (_, {getState}) => {
      return getIsFeatureEnabled(getState(), FeatureToggle.EmployeeCommunication);
    },
  },
);

export const dismissUserAnnouncement = createAsyncThunk<void, {id: string}, AppThunkApiConfig>(
  'employeeCommunication/dismissUserAnnouncement',
  async ({id}, {extra}) => {
    const api = mapiqApi(extra.apiClient);
    await api.postDismissUserAnnouncement(id);

    return;
  },
  {
    condition: (_, {getState}) => {
      return getIsFeatureEnabled(getState(), FeatureToggle.EmployeeCommunication);
    },
  },
);
